import { IState } from "./state";
import { ActionTree, Store, ActionContext } from 'vuex';
import * as api from '../api';
import { ISearchParams } from "../api";

type PayloadType = 'initApp' | 'setState'
| 'search' | 'setLoading' 
| 'setItems' | 'setTotal'
| 'setSort' | 'setDates'

export type ActionPayload<ActionData> = {
    type: PayloadType,
    payload: ActionData
}

type ActionHandler<ActionData> = (this: Store<IState>, injectee: ActionContext<IState, IState>, payload: ActionPayload<ActionData>) => any;
type ActionCreator<ActionData> = (data: ActionData) => ActionPayload<ActionData>;


// Action creators
export const initApp: ActionCreator<IState> = (state) => ({
    type: 'initApp',
    payload: state
})

export const search: ActionCreator<string> = (payload) => ({
    type: 'search',
    payload
})

// Action handlers
const initAppAction: ActionHandler<IState> = ({ commit }, { payload }) => {
    commit({
        type: 'setState',
        payload
    })
}

const searchAction: ActionHandler<string> = ({ commit, state }, { payload }) => {

    const searchParams: ISearchParams = {
        numberToShow: state.numberToShow,
        sortBy: state.selectedSort,
        start: state.start,
        end: state.end,
        operations: state.selectedOperations,
        //professions: state.selectedProfessions,
        subjects: state.selectedSubjects,
        themes: state.selectedThemes,
        blogNames: state.selectedBlogs,
    }

    commit({
        type: 'setLoading',
        payload: true
    })

    api.search(state.url, searchParams)
        .then(res => {
            commit({
                type: 'setItems',
                payload: res.items
            })
            commit({
                type: 'setTotal',
                payload: res.total
            })
        })

    commit({
        type: 'setLoading',
        payload: false
    })

    let urlParams = new URLSearchParams();
    for (let key in searchParams) {
        if (searchParams[key]) {
            urlParams.append(key, searchParams[key].toString());
        }
    }

    let url = `?${urlParams.toString()}`;
    window.history.replaceState({}, document.title, url);
}

const actions: ActionTree<IState, IState> = {
    initApp: initAppAction,
    search: searchAction,
}

export default actions;
